(() => {
  const checkoutBtn = document.querySelector(".cart__checkout-button");
  if(checkoutBtn) {
      checkoutBtn.addEventListener("click", e => {
          handleExpandTE();
      }, 1)
  }

  function handleExpandTE(){
      const isOpen = document.querySelector(".details.discount-details").hasAttribute("open");
      const btnExpand = document.querySelector(".cart-discount__summary");
      if(!isOpen && btnExpand) {
          btnExpand.click();
      }
  }
})();

document.addEventListener("BSS:openCartSlider", e => {
  for(let i=0; i<3; ++i) {
    setTimeout(() => {
      handleCartSlider();
    }, 1000 + i * 500);
  }
})

document.addEventListener("BSS:updateCartSlider", e => {
  for(let i=0; i<3; ++i) {
    setTimeout(() => {
      handleCartSlider();
    }, 1000 + i * 500);
  }
})

function handleCartSlider(){
  const isShowTE = document.body.hasAttribute("show-vat");
  const isExistsTE = document.querySelector("cart-items-component .bss-b2b-tax-ex-wrapper")
  if(!isShowTE || isExistsTE) return;
  disableCheckoutButton();
  const vatNumber = document.querySelector("[vat-number-customer]").getAttribute('vat-number-customer');
  const detailContent = `
    <div class="cart-actions">
<cart-discount-component data-section-id="sections--25350681231697__header_section">
  <accordion-custom class="cart-discount">
    <details class="details discount-details" declarative-open="">
      <summary class="cart-discount__summary">
        <span class="cart-discount__label h6">Vat Exempt</span>

        <span class="svg-wrapper icon-plus"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path class="vertical" d="M2.75 7H11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"></path>
  <path class="horizontal" d="M7 2.75L7 11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"></path>
</svg>
</span>
      </summary>

      <div class="details-content">
        <div class="bss-b2b-tax-ex-wrapper bss-config-header" show-wrapper="0">
    <h3 class="bss-vat-exempt-form-header-text">
        <span class="bss-b2b-translation-vat-form_header_text">EU VAT ID</span>
        <span class="bss-b2b-translation-vat-form_header_text_uk">UK VAT Registration Number</span>
        <span class="bss-b2b-translation-vat-form_header_text_abn">ABN Registration Number</span>
        <span class="bss-b2b-translation-vat-form_header_text_gst">India GST Identification Number</span>
        <span class="bss-b2b-translation-vat-form_header_text_us_ein">US EIN Registration Number</span>
    </h3>
    <p class="bss-vat-exempt-form-subtitle-text">
        <span class="bss-b2b-translation-vat-form_subtitle_text">(VAT will be deducted at payment step)</span>
        <span class="bss-b2b-translation-vat-form_subtitle_text_uk">(UK VAT will be deducted at payment step)</span>
        <span class="bss-b2b-translation-vat-form_subtitle_text_abn">(ABN will be deducted at payment step)</span>
        <span class="bss-b2b-translation-vat-form_subtitle_text_gst">(India GST will be deducted at payment step)</span>
        <span class="bss-b2b-translation-vat-form_subtitle_text_us_ein">(US Tax will be deducted at payment step)</span>
    </p>
    <div class="bss-b2b-vat-input-wrapper">
      <select name="bss-b2b-vat-selected" class="bss-b2b-vat-selected">
         <option value="0">EU</option> 
      </select>
      <input type="text" name="bss-b2b-eu-tax" class="bss-b2b-vat-input" value="${vatNumber}">
    </div>
    <div class="bss-b2b-tax-ex-message">
      <p class="bss-b2b-tax-invalid">
        <span class="tax-icon-error">✕</span>
        <span class="tax-message tax-error-message">
            <span class="bss-b2b-translation-vat-form_error_message">Please enter a valid EU VAT ID (e.g. DK123..., FR123...)</span>
            <span class="bss-b2b-translation-vat-form_error_message_uk">Please enter a valid UK VAT Registration Number</span>
            <span class="bss-b2b-translation-vat-form_error_message_abn">Please enter a valid ABN Registration Number</span>
            <span class="bss-b2b-translation-vat-form_error_message_gst">Please enter a valid India GST Identification Number</span>
            <span class="bss-b2b-translation-vat-form_error_message_us_ein">Please enter a valid US EIN Number.</span>
            <span class="bss-b2b-translation-vat-form_validate_country_code_message">Your country is not eligible for VAT Exemption in this store.</span>
        </span>
      </p>
      <p class="bss-b2b-tax-valid">
        <span class="tax-icon-success">✓</span>
        <span class="tax-message tax-success-message">
            <span class="bss-b2b-translation-vat-form_success_message">Your VAT ID has been successfully validated.</span>
            <span class="bss-b2b-translation-vat-form_success_message_uk">Your UK VAT Registration Number has been successfully validated.</span>
            <span class="bss-b2b-translation-vat-form_success_message_abn">Your ABN Registration Number has been successfully validated.</span>
            <span class="bss-b2b-translation-vat-form_success_message_gst">Your India GST Identification Number has been successfully validated.</span>
            <span class="bss-b2b-translation-vat-form_success_message_us_ein">Your EIN Number has been successfully validated.</span>
        </span>
      </p>
    </div>
  </div>
      </div>
    </details>
  </accordion-custom>
</cart-discount-component>
    </div>
  `;
  const target = document.querySelector(".cart-actions:has(+.cart__total-container)");
  target.insertAdjacentHTML("beforebegin", detailContent);
}


function disableCheckoutButton() {
  const styleId = "disable-checkout-style";

  if (!document.getElementById(styleId)) {
    const style = document.createElement("style");
    style.id = styleId;
    style.textContent = `
      .cart__checkout-button {
        pointer-events: none !important;
        opacity: 0.6 !important;
      }
    `;
    document.head.appendChild(style);
  }

  setTimeout(enableCheckoutButton, 1000);
}

function enableCheckoutButton() {
  const style = document.getElementById("disable-checkout-style");
  if (style) {
    style.remove();
  }
}
